import { useTranslation } from 'react-i18next';

import { useModal } from '@/components/providers/ModalProvider/ModalProvider';
import CreateTaskModal from '@/features/crm/components/CreateTaskModal/CreateTaskModal';
import PickCRMModal from '@/features/crm/components/PickCRMModal/PickCRMModal';
import useCrm from '@/features/crm/hooks/useCrm';
import type {
  CreateTaskVariables,
  CreateTaskVariablesAnva,
  CreateTaskVariablesAssu,
  CRM,
} from '@/features/crm/types';
import type { Action } from '@/types/actions';

import useSelectedParty from './useSelectedParty';

type DefaultValues = Partial<
  CreateTaskVariables & CreateTaskVariablesAnva & CreateTaskVariablesAssu
>;

export default function useSetReminder(action: Action) {
  const { t } = useTranslation();
  const { showModal } = useModal();

  const party = useSelectedParty();

  const { availableCrms } = useCrm();

  const getDefaultValues = (): DefaultValues => ({
    title: action.metadata?.title as string | undefined,
    description: action.metadata?.description as string | undefined,
    priority:
      typeof action.metadata?.priority === 'string'
        ? (Number(action.metadata?.priority) as 1 | 2 | 3)
        : undefined,
    dueDate: action.metadata?.due_date as string | undefined,
    crmPolicyId: action.metadata?.anva_policy_id as Maybe<string>,
  });

  const showCreateTaskModal = (crm: CRM) => {
    const defaultValues = getDefaultValues();

    showModal(
      CreateTaskModal,
      { crm, defaultValues, party },
      {
        size: 'full',
        title: t('CREATE_TASK_TITLE', {
          crm: t(`CRM_NAME_${crm.toUpperCase()}`),
        }),
      },
    );
  };

  return () => {
    showModal(PickCRMModal, {
      onSubmit: showCreateTaskModal,
      description: t('PICK_CRM_CREATE_TASK_DESCRIPTION'),
      availableCrms,
    });
  };
}
